const toStatNumber = v => {
  if (v == null || v === "") return 0
  const n = Number(String(v).replace(/,/g, ""))
  return Number.isFinite(n) ? n : 0
}

function getGrowthChange(
  current,
  prev,
  { wrapped = true, onDark = false } = {}
) {
  const previous = toStatNumber(prev)
  if (previous <= 0) return null
  const pct = Math.round(((toStatNumber(current) - previous) / previous) * 100)
  const green = onDark ? "text-green-300" : "text-green-600"
  const gray = onDark ? "text-white/60" : "text-gray-500"
  if (pct > 0) {
    return {
      label: wrapped ? `(+${pct}%)` : `+${pct}%`,
      className: green,
      direction: "up",
    }
  }
  if (pct < 0) {
    return {
      label: wrapped ? `(${pct}%)` : `${pct}%`,
      className: gray,
      direction: "down",
    }
  }
  return {
    label: wrapped ? "(0%)" : "0%",
    className: gray,
    direction: null,
  }
}

export { getGrowthChange, toStatNumber }
